import React from "react";
import {
  gitchaExplainerUrl,
  trackGitchaExplainerClick,
} from "@/helpers/gitchaExplainer";
import "./GitchaSyndicationCard.scss";

const GitchaSyndicationCard = ({ checked, onChange }) => (
  <div className="finance-wrap agent-create-label gitcha-synd-field">
    <h6>Want-Listing Syndication</h6>
    <div className="wantad-type-wrap pb-0">
      <div className="row">
        <label className="check-wrap mb-3">
          <input
            type="checkbox"
            name="property_checkbox"
            checked={checked}
            onChange={onChange}
          />
          <span>
            <div className="wantad-type-info">
              <h2 className="pb-0 wanted-info-list">
                Syndicate to the public via <b className="gitcha-brand">Gitcha.com</b>
              </h2>
              <p className="gitcha-synd-field__help">
                Share this Want&#8209;Listing beyond your members&#8209;only&nbsp;network.
                For the first time, your buy&#8209;side work earns you exposure and
                more&nbsp;opportunities.
              </p>
              <a
                className="gitcha-synd-field__link"
                href={gitchaExplainerUrl("want_listing_form")}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  e.stopPropagation();
                  trackGitchaExplainerClick("want_listing_form");
                }}
              >
                How Gitcha.com works for buyer&nbsp;agents&nbsp;&rarr;
              </a>
            </div>
          </span>
        </label>
      </div>
    </div>
  </div>
);

export default GitchaSyndicationCard;
